'use client';

import { useTranslations } from 'next-intl';
import { Container, ButtonV2 } from 'components/shared';
import { useReviews } from './useReviews';
import { ReviewCard } from './ReviewCard';
import styles from './ReviewsSection.module.css';

export const ReviewsSection = ({
  className,
  htmlId,
}: {
  className?: string;
  htmlId?: string;
}) => {
  const t = useTranslations('ring');
  const tCommon = useTranslations('common');
  const { reviews, loading, error } = useReviews({
    limit: 14,
    page: 1,
    requireContent: true,
    sort: 'short,date,media',
    order: 'dsc',
    minRating: 4,
    hasMedia: false,
    maxContentLength: 600,
  });

  return (
    <section
      className={`${styles.root}${className ? ` ${className}` : ''}`}
      id={htmlId}
    >
      <Container className={styles.reviewsContainer}>
        <div className={styles.reviewsHeader}>
          <h2 className={styles.reviewsTitle}>{t('ring.reviewsSection.title')}</h2>
          <ButtonV2
            className={`${styles.viewAllButton} ${styles.viewAllDesktop}`}
            href="/ring/reviews"
            data-buttontype="reviews_view_all_button"
          >
            {t('ring.reviewsSection.button')}
          </ButtonV2>
        </div>

        {loading && (
          <p className={styles.reviewsPlaceholder}>
            {tCommon('reviewsSection.text.loadingReviews')}
          </p>
        )}

        {error && <p className={styles.reviewsPlaceholder}>{error}</p>}

        {!loading && !error && reviews.length === 0 && (
          <p className={styles.reviewsPlaceholder}>
            {tCommon('reviewsSection.text.noReviewsAvailable')}
          </p>
        )}

        {!loading && !error && reviews.length > 0 && (
          <div className={styles.reviewsBento}>
            {reviews.map((review) => (
              <ReviewCard key={review.review_id} review={review} />
            ))}
          </div>
        )}
      </Container>
      <ButtonV2
        className={styles.viewAllButtonMobile}
        href="/ring/reviews"
        data-buttontype="reviews_view_all_button_mobile"
      >
        {t('ring.reviewsSection.button')}
      </ButtonV2>
      <div className={styles.gradientOverlay} />
    </section>
  );
};
